export default function (donationsService) {
  let vm;
  let weekDays = ['א\'', 'ב\'', 'ג\'', 'ד\'', 'ה\'', 'ו\'', 'מוצ"ש'];

  class DonationsSummaryController {
    constructor () {
      vm = this;
      vm.donationsService = donationsService;
    }

    getWeekDay (date) {
      return weekDays[new Date(date).getDay()];
    }
  }

  return new DonationsSummaryController();
}



// WEBPACK FOOTER //
// ./client/app/components/donations-summary/donations-summary.controller.js